import { Box, Button, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { useAuth } from "Providers/AuthProvider";
import { useLoading } from "Providers/LoadingProvider";
import { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { TbLock } from "react-icons/tb";

function ModuleLocked() {
    const loading = useLoading();
    const user = useAuth().getUser();
    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    useEffect(() => {
        loading.hide();
    });

    return (
        <Flex justify="center" align="center" minH="60vh">
            <Box
                bg={cardBg}
                borderRadius="xl"
                overflow="hidden"
                boxShadow="lg"
                border="1px solid"
                borderColor={borderColor}
                maxW="500px"
                w="full"
                mx={4}
            >
                <Box bg="linear-gradient(135deg, #DD6B20 0%, #C05621 100%)" py={6} px={6}>
                    <Flex align="center" justify="center" direction="column">
                        <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="full" p={4} mb={3}>
                            <Icon as={TbLock} color="white" boxSize={8} />
                        </Flex>
                        <Text color="white" fontWeight="bold" fontSize="2xl" textAlign="center">
                            Módulo Bloqueado
                        </Text>
                    </Flex>
                </Box>
                <Box p={8} textAlign="center">
                    <Text fontSize="md" mb={4} color="gray.600" _dark={{ color: "gray.400" }}>
                        Você não possui acesso a este módulo no momento!
                    </Text>
                    <Text fontSize="sm" mb={6} color="gray.500">
                        Para projetos personalizados de Balanço Hídrico, entre em contato conosco pelo WhatsApp.
                    </Text>
                    <Button
                        colorScheme="whatsapp"
                        leftIcon={<FaWhatsapp fontSize={20}/>}
                        size="lg"
                        borderRadius="xl"
                        as={"a"}
                        target="_blank"
                        href={"https://wa.me/553591851089?text=Ol%C3%A1%21%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Balan%C3%A7o%20H%C3%ADdrico%20no%20WS%20Clima"}
                    >
                        William - (35) 9185-1089
                    </Button>
                </Box>
            </Box>
        </Flex>
    );
}

export default ModuleLocked;
